<form #form [action]="url" method="post" target="_blank">
  <input *ngFor="let id of ids" name="id" type="hidden" [value]="id" />
</form>
